module.exports = __webpack_public_path__ + "assets/img/img-detail.1ba07143.jpg";